export const COLUMN_COUNT = 12;
export const ROW_HEIGHT = 50;

export const DEFAULT_LAYOUT = [
  {
    x: 0,
    y: 0,
    w: 12,
    h: 6,
    i: '0',
    widget: {
      id: '1',
      module: 'TICKET',
      type: 'LISTVIEW',
      name: 'All Tickets',
      shared: true,
      viewCondition: {
        operands: [
          {
            attribute: 'displayId',
            operator: 'isNotEmpty',
            value: null
          }
        ],
        joinOperator: 'AND'
      },
      customView: false
    }
  }
];
